import React, { SVGProps } from "react";

export default function SupPortfolio(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 7.33339H16.2222V5.55561H10.3682C9.56329 5.55561 8.79136 5.23587 8.22222 4.66672C7.65307 4.09757 6.88115 3.77783 6.07625 3.77783H5.55555C3.59188 3.77783 2 5.36971 2 7.33338V12.6667C2 14.6304 3.59188 16.2223 5.55555 16.2223H13.3074C15.0022 16.2223 16.4615 15.026 16.7939 13.364L18 7.33339ZM3.72221 12.1437C3.39219 13.7938 4.6543 15.3334 6.33709 15.3334H13.3074C14.4196 15.3334 15.3966 14.6464 15.7905 13.6397C15.8467 13.4958 15.8911 13.3455 15.9222 13.1897L16.9157 8.22227H6.69264C5.58039 8.22227 4.60343 8.90921 4.20956 9.91598C4.15329 10.0598 4.10892 10.2102 4.07776 10.366L3.72221 12.1437ZM2.88889 11.7779L3.20614 10.1916C3.30493 9.69766 3.50328 9.24482 3.77778 8.8523C4.4268 7.92423 5.50154 7.33339 6.69264 7.33339H15.3333V6.4445H10.3682C9.32754 6.4445 8.32952 6.0311 7.59368 5.29526C7.19123 4.89281 6.6454 4.66672 6.07625 4.66672H5.55555C4.08279 4.66672 2.88889 5.86063 2.88889 7.33338V11.7779Z"
        fill="currentColor"
      />
    </svg>
  );
}
